
import placeholer from "./placeholer.js"
import register from "./register.js"

export default {
    ...placeholer,
    ...register
}